import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { Ruler, DollarSign, Calculator, RotateCcw } from 'lucide-react';

const RATE = 100;

const Calculadora = () => {
  const [largo, setLargo] = useState('');
  const [ancho, setAncho] = useState('');
  const [alto, setAlto] = useState('');

  const l = parseFloat(largo) || 0;
  const w = parseFloat(ancho) || 0;
  const h = parseFloat(alto) || 0;

  const volumen = l * w * h;
  const piesCubicos = volumen / 1728;
  const factor = piesCubicos / 5.25;
  const precio = factor * RATE;

  const hasInput = l > 0 && w > 0 && h > 0;

  const reset = () => {
    setLargo('');
    setAncho('');
    setAlto('');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 p-3 sm:p-6 pb-24">
      <div className="max-w-xl mx-auto space-y-6">
        <Card className="shadow-xl border-2 border-blue-100 overflow-hidden">
          <CardHeader className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-white/20 rounded-lg">
                <Calculator className="h-8 w-8" />
              </div>
              <div>
                <CardTitle className="text-2xl font-bold">Calculadora de Envio</CardTitle>
                <p className="text-blue-100 text-base">(L x A x H) / 1728 / 5.25 x 100</p>
              </div>
            </div>
          </CardHeader>
          <CardContent className="p-5 space-y-5">
            {/* Dimensions */}
            <div>
              <Label className="text-base font-bold text-gray-700 flex items-center gap-2 mb-3">
                <Ruler className="h-4 w-4 text-blue-600" /> Dimensiones (pulgadas)
              </Label>
              <div className="grid grid-cols-3 gap-3">
                <div className="space-y-1">
                  <Label className="text-sm font-semibold text-gray-500">Largo</Label>
                  <Input
                    data-testid="calc-largo"
                    type="number"
                    min="0"
                    step="0.1"
                    value={largo}
                    onChange={(e) => setLargo(e.target.value)}
                    placeholder="18"
                    className="h-14 text-2xl font-bold text-center border-2 focus:border-blue-500"
                  />
                </div>
                <div className="space-y-1">
                  <Label className="text-sm font-semibold text-gray-500">Ancho</Label>
                  <Input
                    data-testid="calc-ancho"
                    type="number"
                    min="0"
                    step="0.1"
                    value={ancho}
                    onChange={(e) => setAncho(e.target.value)}
                    placeholder="18"
                    className="h-14 text-2xl font-bold text-center border-2 focus:border-blue-500"
                  />
                </div>
                <div className="space-y-1">
                  <Label className="text-sm font-semibold text-gray-500">Alto</Label>
                  <Input
                    data-testid="calc-alto"
                    type="number"
                    min="0"
                    step="0.1"
                    value={alto}
                    onChange={(e) => setAlto(e.target.value)}
                    placeholder="28"
                    className="h-14 text-2xl font-bold text-center border-2 focus:border-blue-500"
                  />
                </div>
              </div>
            </div>

            {/* Calculation Steps */}
            {hasInput && (
              <div className="bg-gray-50 rounded-xl border-2 border-gray-200 p-4 space-y-2">
                <p className="text-sm font-bold text-gray-400 uppercase tracking-wide">Desglose</p>
                <div className="space-y-1.5 text-base">
                  <div className="flex justify-between">
                    <span className="text-gray-600">{l} x {w} x {h}</span>
                    <span className="font-bold">{volumen.toLocaleString()} pulg³</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">{volumen.toLocaleString()} / 1728</span>
                    <span className="font-bold">{piesCubicos.toFixed(2)} ft³</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">{piesCubicos.toFixed(2)} / 5.25</span>
                    <span className="font-bold">{factor.toFixed(4)}</span>
                  </div>
                  <div className="flex justify-between pt-1 border-t border-gray-300">
                    <span className="text-gray-600">{factor.toFixed(4)} x $100</span>
                    <span className="font-black text-green-700 text-lg">${precio.toFixed(2)}</span>
                  </div>
                </div>
              </div>
            )}

            {/* Result */}
            <div className="rounded-xl border-2 border-blue-200 bg-gradient-to-r from-blue-50 via-white to-indigo-50 p-5">
              <div className="text-center">
                <p className="text-sm font-bold text-blue-400 uppercase tracking-wide mb-1">Precio</p>
                <p className="text-5xl font-black text-blue-700" data-testid="calc-precio">
                  ${precio.toFixed(2)}
                </p>
              </div>
            </div>

            {/* Reset */}
            <Button
              data-testid="calc-reset"
              type="button"
              variant="outline"
              onClick={reset}
              className="w-full h-12 text-base"
            >
              <RotateCcw className="mr-2 h-4 w-4" /> Limpiar
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Calculadora;
